import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-likes-count',
  templateUrl: './likes-count.component.html',
  styleUrls: ['./likes-count.component.css']
})
export class LikesCountComponent {
  @Input() liked = false;
  @Input() likesCount: number = 0;
  @Input() likeCountOnly: boolean = false;
  @Input() tooltipText: string = "";
  @Input() displayAsButton: boolean = false;
  @Output() likedChange = new EventEmitter<boolean>();

  tooltipVisible = false;
  tooltipLeft = 0;
  tooltipTop = 0;

  getLikeLabel(): string {
    if (this.likeCountOnly) {
      return "";
    }

    return ` ${(this.likes == 1) ? 'like' : 'likes'}`;
  }

  get wrapperCss() {
    return {
      'likes-count-button': this.displayAsButton,
      'liked': this.liked,
      'unliked': !this.liked
    };
  }

  get likes(): number {
    return this.likesCount;
  }

  showTooltip(event: MouseEvent) {
    this.tooltipVisible = true;
    const containerWidth = (event.target as HTMLElement).offsetWidth;
    const tooltipWidth = 450;

    this.tooltipLeft = (containerWidth - tooltipWidth) / 2 + 200;
    this.tooltipTop = -60;
  }

  hideTooltip() {
    this.tooltipVisible = false;
  }

  toggleLike() {
    if (this.displayAsButton) {
      this.likedChange.emit(!this.liked);
    }
  }
}
